module.exports = __webpack_public_path__ + "media/images/emblems/wappen_von_berneck-c50c4b62d1f60ceb206495635e019ebb.png";